import { Box, Button, Divider, Drawer, Stack, Typography } from "@mui/material";
import React from "react";

import MenuOpenTwoToneIcon from "@mui/icons-material/MenuOpenTwoTone";
import { NavLink } from "react-router-dom";

const NavDrawer = ({ data }) => {
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        height: anchor === "top" || anchor === "bottom" ? "auto" : "100vh",
        bgcolor: "#175675",
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box
        my={2}
        textAlign="center"
        sx={{ fontWeight: "700", fontSize: "22px", color: "white" }}
      >
        Logo here
      </Box>
      <Divider />
      <Stack direction="column" alignItems="center" gap={2} mt={5}>
        {data.map(({ name, to }, i) => (
          <>
            <Typography
              variant="h6"
              key={i}
              sx={{
                color: "black",
                display: "block",
                fontSize: "15px !important",
                marginRight: "1.5 rem",
                cursor: "pointer",
              }}
            >
              <NavLink
                to={to}
                style={{ textDecoration: "none", color: "white" }}
              >
                {name}
              </NavLink>
            </Typography>
          </>
        ))}
        <Button
          sx={{
            my: 2,
            color: "white",
            display: "block",
            background:
              "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
          }}
        >
          WhitePaper
        </Button>
      </Stack>
    </Box>
  );

  return (
    <div>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}>
            <MenuOpenTwoToneIcon />
          </Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
};

export default NavDrawer;
